import { render } from "./kitoblar.vue?vue&type=template&id=a64ef7d2"
import script from "./kitoblar.vue?vue&type=script&lang=js"
export * from "./kitoblar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__